// Entries and active-state rules of the owner side menu (D14). Pure module: no React, no history. The active entry is computed from a
// path given by the route, so the server render and the browser agree.
export const OWNER_MENU_PATHS = {
  dashboard: '/owner/dashboard',
  vehicles: '/cars',
  upcoming: '/reservation/current',
  previous: '/reservation/previous',
  earnings: '/owner/earnings',
  messages: '/inbox',
};

// Order of the entries. `key` is also the suffix of the message key (ormDashboard...). Reservations is ONE entry with two sub-links.
export const OWNER_MENU_SECTIONS = ['dashboard', 'vehicles', 'reservations', 'earnings', 'messages'];

// Keeps only the path: no query string, no hash, no trailing slash ('/cars/?a=1' -> '/cars').
export const normalizeMenuPath = (value) => {
  if (typeof value !== 'string') return '';
  const path = value.split('#')[0].split('?')[0];
  return path.length > 1 ? path.replace(/\/+$/, '') : path;
};

// { section, sub } : section is one of OWNER_MENU_SECTIONS or null ; sub is 'current' | 'previous' | null (only for reservations).
// '/dashboard' (the renter dashboard) and '/cars/:id' (a public vehicle page) are NOT owner menu pages.
export const getOwnerMenuActive = (value) => {
  const path = normalizeMenuPath(value);
  if (path === OWNER_MENU_PATHS.dashboard) return { section: 'dashboard', sub: null };
  if (path === OWNER_MENU_PATHS.vehicles) return { section: 'vehicles', sub: null };
  if (path === OWNER_MENU_PATHS.upcoming) return { section: 'reservations', sub: 'current' };
  if (path === OWNER_MENU_PATHS.previous) return { section: 'reservations', sub: 'previous' };
  if (path === OWNER_MENU_PATHS.earnings) return { section: 'earnings', sub: null };
  if (path === OWNER_MENU_PATHS.messages) return { section: 'messages', sub: null };
  return { section: null, sub: null };
};
